module.exports = __webpack_public_path__ + "static/img/posterProduct2.36af51a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posterProduct2.png
// module id = jZ4x
// module chunks = 2